import React, { useEffect, useState } from 'react'
import moment from 'moment'
import { Input } from 'rsuite'
import Rate from './components/Rate'
import { connect } from 'react-redux'
import { Container, Number } from './styles'
import BgImage from '../../components/ImageBack'
import { getNpsProfile, setRateNps } from '../../services/api'
import { Loader } from '../../styles/components'

function setShowNavbar(status) {
    return {
        type: 'SET_SHOW_NAVBAR',
        status: status,
    }
}

function Rating({ npsData, dispatch, onBack, globalColors, brandSettings }) {
    const [text, setText] = useState('')
    const [data, setData] = useState([])
    const [rates, setRates] = useState([])
    const [loadingInit, setLoadingInit] = useState(true)
    const [isDone, setIsDone] = useState(false)
    const [loading, setLoading] = useState(false)
    const [activeRT, setActiveRT] = useState(null)
    const [npsProfile, setNpsProfile] = useState([])

    const onSubmit = async () => {
        setLoading(true)
        await setRateNps({
            _id: data?._id,
            status: 'answered',
            ratings: rates,
            rating_comment: text,
            answered_date: moment().format(),
        })
        setIsDone(true)
        // dispatch(setShowNavbar(true))
        // onBack()
        setLoading(false)
    }

    useEffect(() => {
        try {
            setLoadingInit(true)
            setData(npsData)
            if (npsData?.nps_profile) {
                getNpsProfile(npsData?.nps_profile).then((res) => {
                    if (res && res[0]) {
                        setNpsProfile(res[0])
                    }
                    setLoadingInit(false)
                })
            }
        } catch (error) {
            setLoadingInit(true)
        }
    }, [npsData])
    useEffect(() => {
        dispatch(setShowNavbar(false))
    }, [dispatch])
    useEffect(() => {
        if (!data?._id) return
        setRateNps({
            _id: data._id,
            access_date: moment().format(),
        })
    }, [data])

    if (!npsProfile) return

    if (loadingInit)
        return (
            <>
                <Loader />
            </>
        )

    return (
        <Container animale={true} globalColors={globalColors}>
            <div className="logo">
                <img src={brandSettings?.logo?.[0]?.url || ''} alt="logo" />
            </div>
            {isDone ? (
                <div className="flex items-center justify-center flex-1 w-full text-2xl whitespace-pre-wrap text-center">
                    {npsProfile?.message_answered ||
                        'Obrigado pela sua resposta!'}
                </div>
            ) : (
                <>
                    <div className="title mb-4">
                        <strong className="message_title">
                            {npsProfile?.title}
                        </strong>
                        <span>{npsProfile?.subtitle}</span>
                    </div>
                    <div className="mb-4 w-full">
                        <BgImage
                            height={180}
                            url={`${process.env.REACT_APP_API_URL}/modules/image/${npsData?.package}/300-450`}
                        />
                        <div className="text-center font-bold">
                            {npsData?.package}
                        </div>
                    </div>
                    {npsProfile?.welcome_message && (
                        <span className="message_description">
                            {npsProfile?.welcome_message}
                        </span>
                    )}
                    {npsProfile?.ratings_text && (
                        <div className="rate">
                            <span className="title_question font-normal">
                                {npsProfile.ratings_text}
                            </span>
                            <div className="rate-number w-full">
                                {Array.from(
                                    Array(
                                        (npsProfile.ratings_to || 10) -
                                            (npsProfile.ratings_from - 1)
                                    ).keys()
                                ).map((key) => (
                                    <Number
                                        key={key}
                                        animale={true}
                                        className="evaluation_numbers"
                                        active={
                                            activeRT ? key <= activeRT : false
                                        }
                                        onClick={() => {
                                            setActiveRT(key)
                                            let _rateIdx = rates.findIndex(
                                                (e) => e._id === 'rttext'
                                            )
                                            if (_rateIdx !== -1) {
                                                rates[_rateIdx].value =
                                                    npsProfile?.ratings_from +
                                                    key
                                            } else {
                                                rates.push({
                                                    _id: 'rttext',
                                                    name: npsProfile.ratings_text,
                                                    value:
                                                        npsProfile?.ratings_from +
                                                        key,
                                                })
                                            }
                                            setRates([...rates])
                                        }}
                                    >
                                        {npsProfile?.ratings_from + key}
                                    </Number>
                                ))}
                            </div>
                        </div>
                    )}
                    {npsProfile?.ratings?.map((rate) => (
                        <Rate rate={rate} rates={rates} setRates={setRates} />
                    ))}
                    {npsProfile?.show_comment_field && (
                        <div className="flex flex-col gap-2">
                            <div className="text-black font-semibold">
                                OS DETALHES SÃO IMPORTANTES PARA NÓS. FIQUE A
                                VONTADE PARA FAZER QUALQUER COMENTÁRIO.
                            </div>
                            <Input
                                className="textarea"
                                as="textarea"
                                rows={3}
                                placeholder="Compartilhe aqui alguma informação adicional que você queira : )"
                                onChange={(e) => setText(e)}
                                style={{ fontSize: 14, minHeight: 100 }}
                            />
                        </div>
                    )}
                    <div className="actions">
                        <button
                            className="button_send"
                            onClick={() => onSubmit()}
                            disabled={loading}
                        >
                            {loading ? 'Enviando...' : 'Enviar avaliação'}
                        </button>
                        <strong
                            className="message_thanks"
                            style={{ cursor: 'pointer' }}
                            onClick={() => {
                                setRateNps({
                                    _id: data._id,
                                    status: 'skipped',
                                    answered_date: moment().format(),
                                })
                                setIsDone(true)
                                // dispatch(setShowNavbar(true))
                                // onBack()
                            }}
                        >
                            Obrigado, mas não quero avaliar
                        </strong>
                    </div>
                </>
            )}
        </Container>
    )
}

export default connect((state) => ({
    showNavbar: state?.showNavbar,
    globalColors: state?.globalColors,
    brandSettings: state?.brandSettings,
}))(Rating)
